import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders children into the app header's action slot in Shell.
 *
 * The dashboard owns the state behind these buttons (which panel is open, which layers
 * are on, the draw mode), so they cannot simply be moved into Shell. Same portal
 * approach as `SidebarPanel`: keep the state where it belongs and put the controls
 * where the space is.
 *
 * The mount point only exists once Shell has rendered, so resolve it in an effect
 * rather than at module scope — on the first paint it is legitimately absent.
 */
export default function HeaderActions({ children }: { children: React.ReactNode }) {
  const [host, setHost] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setHost(document.getElementById('ww-header-actions'));
  }, []);

  if (!host) return null;
  return createPortal(children, host);
}
